<template>
  <v-main>
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-container fluid>
      <v-card>
        <v-card-title> Karyawan </v-card-title>
        <v-form ref="form" v-model="valid" lazy-validation class="pl-4 pr-4">
          <v-row dense>
            <v-col cols="12" sm="6" md="6" class="pr-4">
              <v-sheet color="white" elevation="2">
                <v-responsive :aspect-ratio="16 / 9">
                  <v-img :key="fotoKey" :src="userData.FotoUrl" contain></v-img>
                </v-responsive>
              </v-sheet>
              <v-file-input
                v-model="userData.file_foto"
                accept="image/*"
                prepend-icon="mdi-image"
                show-size
                label="Foto"
                @change="loadImage"
              />
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="userData.nik"
                    label="NIK"
                    outlined
                    dense
                    :rules="userData.nikRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="userData.nama"
                    label="Nama"
                    outlined
                    dense
                    required
                    :rules="userData.namaRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userData.phone"
                    label="No Telepon"
                    outlined
                    dense
                    :rules="userData.phoneRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userData.email"
                    label="Email"
                    outlined
                    dense
                    :rules="userData.emailRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedProfesi"
                    label="Profesi"
                    dense
                    outlined
                    :items="items_profesi"
                    item-text="value"
                    :rules="userData.profesiRules"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h5>Personal Information</h5>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedJenisKelamin"
                    label="Jenis Kelamin"
                    clearable
                    dense
                    outlined
                    :items="items_jenis_kelamin"
                    item-text="value"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedAgama"
                    label="Agama"
                    clearable
                    dense
                    outlined
                    :items="items_agama"
                    item-text="value"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userData.no_ktp"
                    label="No KTP"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userData.tempat_lahir"
                    label="Tempat Lahir"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userData.tanggal_lahir"
                    label="Tanggal Lahir"
                    type="date"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedPropinsi"
                    label="Propinsi"
                    clearable
                    dense
                    outlined
                    :items="items_propinsi"
                    item-text="name"
                    @change="changePropinsi"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedKabupaten"
                    label="Kabupaten/Kota"
                    clearable
                    dense
                    outlined
                    :items="items_kabupaten"
                    item-text="name"
                    @click="getListKabupaten"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedKecamatan"
                    label="Kecamatan"
                    clearable
                    dense
                    outlined
                    :items="items_kecamatan"
                    item-text="name"
                    @click="getListKecamatan"
                    @change="changeKecamatan"
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-combobox
                    v-model="userData.selectedKelurahan"
                    label="Kelurahan"
                    clearable
                    dense
                    outlined
                    :items="items_kelurahan"
                    item-text="name"
                    @click="getListKelurahan"
                  ></v-combobox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="userData.address"
                    label="Alamat Lengkap"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn style="margin-right: 10px" @click="doBatal">Batal</v-btn>
              <v-btn dark color="primary" type="button" @click="doSubmit"
                >Simpan</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <!-- Modal -->
    </v-container>
  </v-main>
</template>

<script>
import NakesService from "../services/NakesService";
import KaryawanService from "../services/KaryawanService";
import CommonService from "../services/CommonService";
import ProfesiService from "../services/ProfesiService";

export default {
  name: "KaryawanAdd",
  components: {},
  data: () => ({
    breadcrumbs: [
      {
        text: "Data Karyawan",
        disabled: false,
        exact: true,
        to: { name: "Karyawan" },
      },
      { text: "Tambah Karyawan", disabled: true },
    ],
    valid: true,
    userData: {
      FotoUrl: "",
      file_foto: null,
      nik: "",
      nama: "",
      email: "",
      phone: "",
      no_ktp: "",
      tempat_lahir: "",
      selectedProfesi: "",
      selectedPropinsi: "",
      selectedKabupaten: "",
      selectedKecamatan: "",
      selectedKelurahan: "",
      tanggal_lahir: "",
      address: "",
      selectedJenisKelamin: "",
      selectedAgama: "",
      nikRules: [(v) => !!v || "NIK harus diisi"],
      namaRules: [(v) => !!v || "Nama harus diisi"],
      phoneRules: [(v) => !!v || "No Telepon harus diisi"],
      emailRules: [(v) => !!v || "Email harus diisi"],
      profesiRules: [(v) => !!v || "Profesi harus diisi"],
    },
    items_profesi: [],
    items_propinsi: [],
    items_kabupaten: [],
    items_kecamatan: [],
    items_kelurahan: [],
    items_jenis_kelamin: [],
    items_agama: [],
    fotoKey: 0,
    options: {
      itemsPerPage: 5,
    },
  }),
  watch: {
    options: {
      handler() {
        this.getNakesFromApi();
      },
      deep: true,
    },
  },
  mounted: async function () {
    this.getListPropinsi();
    this.getListKabupaten();
    this.getListKecamatan();
    this.getListKelurahan();
    this.getListJenisKelamin();
    this.getListAgama();
    this.getListProfesi();
  },
  methods: {
    loadImage: function (data) {
      console.log("loadImage:", data);
      if (data) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.userData.FotoUrl = e.target.result;
          this.fotoKey++;
        };
        reader.readAsDataURL(data);
      } else {
        this.userData.FotoUrl = "";
        this.userData.file_foto = null;
      }
    },

    async getListJenisKelamin() {
      NakesService.jenisKelaminList()
        .then((res) => {
          this.items_jenis_kelamin = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListProfesi() {
      ProfesiService.profesiListAll()
        .then((res) => {
          this.items_profesi = res.data.list_data;

          this.getUser();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListAgama() {
      NakesService.agamaList()
        .then((res) => {
          this.items_agama = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListPropinsi() {
      NakesService.propinsiList()
        .then((res) => {
          this.items_propinsi = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async changePropinsi() {
      this.userData.selectedKabupaten = null;
      this.userData.selectedKecamatan = null;
      this.userData.selectedKelurahan = null;
    },

    async changeKecamatan() {
      this.userData.selectedKelurahan = null;
    },

    async getListKabupaten() {
      NakesService.kabupatenList(this.userData.selectedPropinsi.id)
        .then((res) => {
          this.items_kabupaten = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListKecamatan() {
      NakesService.kecamatanList(this.userData.selectedKabupaten.id)
        .then((res) => {
          this.items_kecamatan = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListKelurahan() {
      NakesService.kelurahanList(this.userData.selectedKecamatan.id)
        .then((res) => {
          this.items_kelurahan = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    doBatal: function () {
      this.$router.go(-1);
    },

    doSubmit: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      KaryawanService.create(this.userData, this.userData.file_foto)
        .then((res) => {
          // console.log(res);
          CommonService.showSuccessToast("Tambah Karyawan berhasil");

          this.$router
            .push("/karyawan-edit/" + res.data.user.id)
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err?.response?.data?.message);
          if (err?.response?.data?.message) {
            CommonService.showErrorToast(err?.response?.data?.message);
          } else {
            CommonService.showErrorToast("Tambah Karyawan gagal. Coba lagi");
          }
        });
    },
  },
};
</script>

<style scoped></style>
